<template>
  <el-timeline :reverse="true">
    <el-timeline-item
      v-for="(log, i) in logs"
      :key="i"
      :timestamp="log.nodeTime + ' ' + dateWeek(log.nodeTime)"
      placement="top"
      type="success"
      icon="el-icon-top"
    >
      <h4 v-html="log.nodeName"></h4>
      <div>
        <div>
          <span
            class="color-danger"
            v-html="'[' + (log.appName || '-') + ']'"
          ></span
          >&nbsp;
          <span v-html="log.content"></span><b v-if="log.remark" class="color-danger">({{ log.remark }})</b>
        </div>
      </div>
    </el-timeline-item>
  </el-timeline>
</template>
<script>
import { getRecordLogs } from "@/api/bed/record";
export default {
  props: {
    recordId: String,
  },
  data() {
    return {
      logs: [],
    };
  },
  created() {
    getRecordLogs(this.recordId).then((res) => {
      this.logs = res.data.data;
    });
  },
  methods: {
    dateWeek: function (nodeTime) {
      let arr = ["日", "一", "二", "三", "四", "五", "六"];
      let dateObj = new Date(nodeTime);
      let dayOfWeek = dateObj.getDay();
      return "星期" + arr[dayOfWeek];
    },
  },
};
</script>
